import React from 'react';

import { referralHeaderURL } from '../Config';
// import KeywordSelector from './keywords/KeywordSelector';
// import PersistentMenu from './keywords/PersistentMenu';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: props.logo,
      brand_name: props.brand_name,
      tagline: props.tagline,
      test: props.test,
      keywords: props.keywords,
      persistent_menu: props.persistent_menu,
      branding: props.branding,
      widget_hide_header: props.widget_hide_header,
    };
    this.ee = props.ee;
  }

  renderButton() {
    const { test, brand_name, branding } = this.props;
    // return ( branding !== false &&
    //     <a 
    //       href={referralHeaderURL} 
    //       className="hu-header-btn-referral hu-a-center hu-d-none hu-s-12 hu-w-bold hu-color_contrast hu-border-color_contrast-fade-07"
    //     >
    //       <div className="primary">
    //         <span>
    //           Powered by <b>Landbot.io</b>
    //         </span>
    //       </div>
    //       <div className="secondary">
    //         <span>
    //           Get your Landbot 🤖
    //         </span>
    //       </div>
    //     </a>
    //   );
    return /*!test*/ true ?
      ( branding !== false &&
        <a 
          href={referralHeaderURL}
          target="_blank"
          className="hu-header-btn-referral hu-a-center hu-d-none hu-s-12 hu-w-bold hu-color_contrast hu-border-color_contrast-fade-07"
        >
          <div className="primary">
            <span>
              Powered by <b>Landbot.io</b>
            </span>
          </div>
          <div className="secondary">
            <span>
              Get your Landbot 🤖
            </span>
          </div>
        </a>
      ) : (
        <a 
          href={`#`} 
          className="hu-header-btn-referral hu-a-center hu-d-none hu-s-12 hu-w-bold hu-color_contrast hu-border-color_contrast-fade-07"
          onClick={() => location.reload()}
        >
          <div className="test">
            <span>Reset chatbot</span>
          </div>
        </a>
      );
  }

  render() {
    const { logo, brand_name, tagline, test, keywords, persistent_menu, branding, widget_hide_header } = this.props;

    return ( !widget_hide_header &&
      <header id="hu-header" className="hu-border-color_contrast-fade hu-background-color_header-background">
        <div className="hu-header-content">
          { logo !== 'none' &&
            <img className="hu-header-logo" src={logo} alt=""/>
          }
          <h1 className="hu-header-brand_name hu-w-bold hu-s-20 hu-color_header-text">
            {brand_name}
          </h1>
          <p className="hu-header-tagline hu-s-14 hu-x-ellipsis hu-color_header-text" title={tagline}>
            {tagline}
          </p>
          { this.renderButton() }
          {/* <KeywordSelector
            keywords={keywords}
            ee={this.ee}
          /> */}
          {/* <PersistentMenu
            persistent_menu={persistent_menu}
            keywords={keywords}
          /> */}
        </div>
      </header>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./app/js/components/Header.js